import { render } from "./Section_Loans.vue?vue&type=template&id=4f814654"
import script from "./Section_Loans.vue?vue&type=script&lang=js"
export * from "./Section_Loans.vue?vue&type=script&lang=js"

import "./Section_Loans.vue?vue&type=style&index=0&id=4f814654&lang=scss"
script.render = render

export default script